<!--
 * @Description: 干部之家配置 列表搜索
-->
<template>
  <el-form class="serach-form" :inline="true" :model="filters" size="small">
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.expireStatus"
        placeholder="有效状态"
      >
        <el-option
          v-for="(item, i) in expireStatusData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        size="small"
        v-model.trim="filters.keyWord"
        placeholder="资源名称"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click="initData"></butn>
      <butn title="重置" @click="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>

<script>
import butn from "@/components/button/index";

export default {
  components: { butn },
  props: {
    expireStatusData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      filters: {
        expireStatus: '2'
      },
    };
  },
  created() {
  },
  methods: {
    initData() {
      const filters = { ...this.filters }
      this.$emit("search", { ...filters, t: new Date().getTime() });
    },
    resetData() {
      this.filters = {
        expireStatus: '2'
      };
      this.initData();
    },
  },
};
</script>

<style lang="scss" scoped>
.serach-form {
  text-align: right;
}
</style>
